export const REQUIRED_FIELD_SYMBOL = '*';
